import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.css']
})
export class InstructionsComponent implements OnInit {

  @Input() name: any;
public instructiontext : string = "";
primaryColor?: string = "";
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  exportAsPDF(divId: any)
  {
    const data: any = document.getElementById(divId);
    if (!data) {
      alert('Content not found!');
      return;
    }
    html2canvas(data, { scale: 2 }).then(canvas => {
      const pdf = new jspdf('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const pageHeightPx = Math.floor((pdfHeight * canvas.width) / pdfWidth);

      // Find a clean seam near the cut (only for the first page) to avoid splitting a line
      const findSeamRow = (approxRow: number): number => {
        const ctx = canvas.getContext('2d');
        if (!ctx) return approxRow;
        const searchRadius = 30;
        const start = Math.max(0, approxRow - searchRadius);
        const end = Math.min(canvas.height - 1, approxRow + searchRadius);
        const sampleCols = 24;
        const stepX = Math.max(1, Math.floor(canvas.width / sampleCols));
        let bestRow = approxRow;
        let bestWhiteRatio = -1;
        // Evaluate rows around the boundary and pick the whitest
        for (let y = start; y <= end; y++) {
          const rowData = ctx.getImageData(0, y, canvas.width, 1).data;
          let whiteCount = 0;
          let total = 0;
          for (let x = 0; x < canvas.width; x += stepX) {
            const i = x * 4;
            const r = rowData[i], g = rowData[i + 1], b = rowData[i + 2], a = rowData[i + 3];
            const isWhite = (a < 8) || (r > 240 && g > 240 && b > 240);
            if (isWhite) whiteCount++;
            total++;
          }
          const ratio = whiteCount / (total || 1);
          if (ratio > bestWhiteRatio) {
            bestWhiteRatio = ratio;
            bestRow = y;
          }
        }
        return bestRow;
      };

      let renderedHeight = 0;
      let pageNum = 0;

      while (renderedHeight < canvas.height) {
        const targetBottom = Math.min(renderedHeight + pageHeightPx, canvas.height);
        const seam = pageNum === 0 && targetBottom < canvas.height
          ? findSeamRow(targetBottom)
          : targetBottom;
        let pageCanvasHeight = Math.max(1, seam - renderedHeight);

        // Create a canvas for the current page slice
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        pageCanvas.height = pageCanvasHeight;
        const ctx = pageCanvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            pageCanvasHeight,
            0,
            0,
            canvas.width,
            pageCanvasHeight
          );
        }
        const imgData = pageCanvas.toDataURL('image/png');
        if (pageNum > 0) { pdf.addPage(); }
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, (pageCanvas.height * pdfWidth) / canvas.width);
        renderedHeight = seam;
        pageNum++;
        // Safety: break if no progress
        if (pageNum > 200) break;
      }
      pdf.save('instructions.pdf');
    });
  }

}
